@let insightfulChatComponentEnabled = insightfulChatComponentEnabled$ | async;
@let hasRelatedContent = htmlReport?.includeRelatedContent && htmlReport?.relatedContent && htmlReport.relatedContent.length;

<div class="content-container">
  <app-content-stage-dropdown
    class="custom-dropdown-position"
    [selectedStage]="selectedStage"
    (stageChange)="onStageChange($event)"
  >
  </app-content-stage-dropdown>
  @if(isContentLoading) {
    <div class="loading-indicator">
      <app-progress-bar-circular></app-progress-bar-circular>
    </div>
  } @else {
    <app-hygraph-header
      *ngIf="htmlReport?.header"
      [date]="htmlReport.publishDate"
      [header]="htmlReport.header"
      [title]="reportTitle"
    ></app-hygraph-header>
    <div class="body">
      <section class="table-of-content" *ngIf="htmlReport.includeTableOfContent && showTableOfContent">
        <app-hygraph-navigation
          [createAnchorHref]="createURLTreeHref.bind(this)"
          [sections]="htmlReport.sections"
        ></app-hygraph-navigation>
      </section>
      <section class="main-section-wrapper">
        <section class="main-section" [class.fit-width]="fitWidth" #mainSection>
          <ng-container *ngFor="let section of htmlReport.sections">
            <div *ngIf="section" class="content-section" id="{{section.title}}">
              <h2 *ngIf="section.title">{{ section.title }}</h2>
              <h3 *ngIf="section.subTitle">{{section.subTitle}}</h3>
              <!-- Reuse the template for section content -->
              <ng-container *ngFor="let content of section.sectionContent">
                <ng-container *ngTemplateOutlet="getTemplate(content); context: { $implicit: content }"></ng-container>
              </ng-container>
                <!-- Recursive rendering of subsections -->
                <ng-container *ngIf="section.subsections && section.subsections.length > 0">
                  <ng-container *ngFor="let subsection of section.subsections">
                    <div *ngIf="subsection" class="content-subsection" id="{{subsection.title}}">
                      <h3 *ngIf="subsection.title">{{ subsection.title }}</h3>
                      <div *ngIf="!subsection.sectionContent || !(subsection.sectionContent.length > 0)" class="locked-section">
                        <em class="icon-locked"></em>
                        <p>{{ lockedMessage }}</p>
                      </div>
                      <!-- Reuse the template for subsection content -->
                      <ng-container *ngFor="let subcontent of subsection.sectionContent">
                        <ng-container *ngTemplateOutlet="getTemplate(subcontent); context: { $implicit: subcontent }"></ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>
            </div>
          </ng-container>
        </section>
        <section class="related-content" *ngIf="(hasRelatedContent || insightfulChatComponentEnabled) && !fitWidth">
          @if(insightfulChatComponentEnabled) {
            <app-insightful-chat-panel-form
              [medium]="isBlog ? type.blog : type.report"
            ></app-insightful-chat-panel-form>
          }
          @if(hasRelatedContent) {
            <app-hygraph-related-content
              [relatedContentItems]="htmlReport.relatedContent"
            ></app-hygraph-related-content>
          }
        </section>
      </section>
    </div>
  }
</div>

<ng-template #sectionImage let-content>
  <div
    class="image-container"
    [ngClass]="content.image.length > 2 ? 'fixed-columns' : 'auto-columns'"
  >
    <div *ngFor="let image of content.image">
      <img
        [src]="image.url"
        alt="Section Image"
        (click)="openImageModal(image)"
        [class.image-grid-item]="content.image.length > 1"
      />
      <div>
        <a [attr.href]="image.sourceUrl" target="_blank">
          {{ image.fileName }}
          <em *ngIf="image.sourceUrl" class="icon-external"></em>
        </a>
        <h5 class="caption">{{ image.caption }}</h5>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #sectionTable let-content>
  <div *ngFor="let html of content.table" [innerHTML]="(html.html | textScripts)" class="hygraph-html-container scroll-container horizontal-scrollbar"></div>
  <h5 *ngIf="content.caption" class="caption">{{ content.caption }}</h5>
</ng-template>

<ng-template #sectionText let-content>
  <div class="body-container" *ngFor="let html of content.body" [innerHTML]="(html.html | textScripts)"></div>
</ng-template>

<ng-template #sectionVisualization let-content>
  <div
    *ngFor="let visualization of content.visualizations"
    class="visual-container horizontal-scrollbar"
  >
    <app-quicksight-visual-viewer
      [visualization]="visualization"
    ></app-quicksight-visual-viewer>
  </div>
</ng-template>
